export default "__VITE_ASSET__BppHmr0y__"